'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

exports.Margins = void 0;
(function(Margins) {
    Margins["Large"] = 'large';
    Margins["Medium"] = 'medium';
    Margins["None"] = 'none';
    Margins["Small"] = 'small';
})(exports.Margins || (exports.Margins = {}));
//# sourceMappingURL=margin.js.map
